import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { register } from "../../actions/userActions";
import Axios from "../../axios/axios";
import imageCompression from "browser-image-compression";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";

const CreateCustomer = () => {
  const dispatch = useDispatch();
  const [uploading, setUploading] = useState(false);
  const [name, setName] = useState("");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [address3, setAddress3] = useState("");
  const [address4, setAddress4] = useState("");
  const [phone, setPhone] = useState("");
  const [phone1, setPhone1] = useState("");
  const [id1, setId1] = useState("");
  const [id1Sec, setId1Sec] = useState("");
  const [id1Name, setId1Name] = useState("");
  const [id2, setId2] = useState("");
  const [id2Sec, setId2Sec] = useState("");
  const [id2Name, setId2name] = useState("");
  const [photo, setPhoto] = useState("");
  const [customerId, setCustomerId] = useState("");

  const [createError, setCreateError] = useState(false);

  const register_ = useSelector((state) => state.register);
  const { success, error } = register_;
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    if (success === true) {
      toast.success("User registered successfully!");
      setTimeout(() => {
        window.location.href = "/users";
      }, 1000);
    }

    if (error) {
      toast.error(error); // This will show "User already exists" or any other backend error
    }
  }, [success, error]);

  const generateCustomerId = (name, phone) => {
    const prefix = (name || "CU")
      .replace(/[^a-zA-Z]/g, "")
      .toUpperCase()
      .substring(0, 2)
      .padEnd(2, "X");

    const phonePart = (phone || "")
      .replace(/\D/g, "")
      .substring(0, 4)
      .padEnd(4, "0");

    const random = Math.random().toString(36).substring(2, 6).toUpperCase();

    return `${prefix}${phonePart}${random}`;
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      dispatch(
        register({
          name,
          email,
          customerId,
          password: phone,
          address1,
          address2,
          address3,
          address4,
          phone,
          phone1,
          id1,
          id1Sec,
          id1Name,
          id2,
          id2Sec,
          id2name: id2Name,
          photo,
        }),
      );

      // toast.success("User registered successfully!"); // 🎉 show toast
    } catch (error) {
      toast.error(error?.message || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  console.log(register);

  useEffect(() => {
    if (!customerId && name && phone) {
      setCustomerId(generateCustomerId(name, phone));
    }
  }, [name, phone]);

  const uploadFileHandler = async (e, val) => {
    console.log("uploading");
    const file = e.target.files[0];
    let compressedFile = file;
    if (file && file.size > 1024 * 1024) {
      try {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeoght: 1920,
          useWebWorker: true,
        };
        compressedFile = await imageCompression(file, options);
        setSelectedFile(compressedFile);
      } catch (error) {
        console.error("Error compressing the image:", error);
      }
    }
    const formData = new FormData();
    formData.append("image", file);
    setUploading(true);

    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      const { data } = await Axios.post("/api/upload", formData, config);

      if (val === "id1") {
        setId1(data);
      } else if (val === "id2") {
        setId2(data);
      } else if (val === "id1Sec") {
        setId1Sec(data);
      } else if (val === "id2Sec") {
        setId2Sec(data);
      } else if (val === "photo") {
        setPhoto(data);
      }
      setUploading(false);
    } catch (error) {
      console.error(error);
      setUploading(false);
    }
  };
  return (
    <div className="row">
      <div class="col-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Create Customer</h4>
            <form class="forms-sample" onSubmit={submitHandler}>
              <div class="form-group">
                <label for="exampleInputName">
                  Customer Name <span style={{ color: "red" }}>*</span>
                </label>

                <input
                  type="text"
                  class="form-control"
                  onChange={(e) => setName(e.target.value)}
                  placeholder="name"
                  value={name}
                  name="name"
                  required={true}
                />
              </div>

              <div class="form-group">
                <label for="exampleInputPriority4">
                  Mobile Phone
                  <span style={{ color: "red" }}>*</span>
                </label>

                <input
                  type="number"
                  className="form-control"
                  placeholder="mobile number"
                  value={phone}
                  required={true}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label>
                  Customer ID <span style={{ color: "red" }}>*</span>
                </label>

                <input
                  type="text"
                  className="form-control"
                  value={customerId}
                  onChange={(e) => setCustomerId(e.target.value.toUpperCase())}
                  required
                />
              </div>

              <div class="form-group">
                <label for="exampleInputName">
                  E mail
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label for="exampleInputPriority4">
                  Place
                  <span style={{ color: "red" }}>*</span>
                </label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Place"
                  value={address1}
                  required={true}
                  onChange={(e) => setAddress1(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label for="exampleInputPriority4">Area</label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Area"
                  value={address4}
                  onChange={(e) => setAddress4(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label for="exampleInputPriority4">Post</label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Post"
                  value={address2}
                  onChange={(e) => setAddress2(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label for="exampleInputPriority4">Pin</label>

                <input
                  type="number"
                  className="form-control"
                  placeholder="Pin"
                  value={address3}
                  onChange={(e) => setAddress3(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label for="exampleInputPriority4">Customer Photo</label>

                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => uploadFileHandler(e, "photo")}
                />
              </div>
              {uploading === true ? (
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              ) : (
                <img
                  src={
                    photo === ""
                      ? process.env.PUBLIC_URL + "/images/select_image.png"
                      : `${photo}`
                  }
                  height="100"
                />
              )}
              <div class="form-group">
                <label for="exampleInputPriority4">Extra Mobile Number</label>

                <input
                  type="number"
                  className="form-control"
                  placeholder="mobile number"
                  value={phone1}
                  onChange={(e) => setPhone1(e.target.value)}
                />
              </div>

              <div class="form-group">
                <label for="exampleInputPriority4">Id Proof 1</label>
                <select
                  className="form-control"
                  value={id1Name}
                  onChange={(e) => setId1Name(e.target.value)}
                >
                  <option value="">Select ID Proof</option>
                  <option value="aadhar">Aadhar</option>
                  <option value="passport">Passport</option>
                  <option value="idproof">ID Proof</option>
                  <option value="license">License</option>
                </select>
              </div>

              <div class="form-group">
                <label for="exampleInputPriority4"> </label>
                <b>1.</b>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => uploadFileHandler(e, "id1")}
                  // required={true}
                />
              </div>
              {uploading === true ? (
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              ) : (
                <img
                  src={
                    id1 === ""
                      ? process.env.PUBLIC_URL + "/images/select_image.png"
                      : `${id1}`
                  }
                  height="100"
                />
              )}
              <div class="form-group">
                <label for="exampleInputPriority4"> </label>
                <b>2.</b>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => uploadFileHandler(e, "id1Sec")}
                  // required={true}
                />
              </div>
              {uploading === true ? (
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              ) : (
                <img
                  src={
                    id1Sec === ""
                      ? process.env.PUBLIC_URL + "/images/select_image.png"
                      : `${id1Sec}`
                  }
                  height="100"
                />
              )}
              <div class="form-group">
                <label for="exampleInputPriority4">Id Proof 2</label>

                <select
                  className="form-control"
                  value={id2Name}
                  onChange={(e) => setId2name(e.target.value)}
                >
                  <option value="">Select ID Proof</option>
                  <option value="aadhar">Aadhar</option>
                  <option value="passport">Passport</option>
                  <option value="idproof">ID Proof</option>
                  <option value="license">License</option>
                </select>
              </div>
              <b>1.</b>
              <input
                type="file"
                className="form-control"
                onChange={(e) => uploadFileHandler(e, "id2")}
                // required={true}
              />
              {uploading === true ? (
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              ) : (
                <img
                  src={
                    id2 === ""
                      ? process.env.PUBLIC_URL + "/images/select_image.png"
                      : `${id2}`
                  }
                  height="100"
                />
              )}
              <br />
              <b>2.</b>
              <input
                type="file"
                className="form-control"
                onChange={(e) => uploadFileHandler(e, "id2Sec")}
                // required={true}
              />
              {uploading === true ? (
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              ) : (
                <img
                  src={
                    id2Sec === ""
                      ? process.env.PUBLIC_URL + "/images/select_image.png"
                      : `${id2Sec}`
                  }
                  height="100"
                />
              )}

              <div class="form-group">
                <label for="exampleInputPriority4">Password</label>

                <input
                  type="text"
                  className="form-control"
                  value={phone}
                  disabled
                />
              </div>
              {createError === true && (
                <div class="alert alert-danger" role="alert">
                  User exist with same mobile number
                </div>
              )}

              {loading ? (
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden"></span>
                </div>
              ) : (
                <div className="bottom-area">
                  <p className="mt-14"></p>
                  <button type="submit" class="btn btn-primary mr-2">
                    Submit
                  </button>
                  <Link to="/users">
                    <button class="btn btn-light">Cancel</button>
                  </Link>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default CreateCustomer;
